import { appConfig } from "../config/config";
import { Job } from "../dtos/job";
import api from "./api/api";

export const getJob = async (jobId?: string): Promise<Job> => {
  if (!jobId || jobId === "undefined" || jobId === "null") {
    throw new Error("Job ID is required and must be valid");
  }
  return api.get<Job>(`common/${appConfig.tenant}/jobs/${jobId}`);
};
